import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/services/common.service';

@Component({
  selector: 'app-wallet-filter',
  templateUrl: './wallet-filter.component.html',
  styleUrls: ['./wallet-filter.component.scss'],
})
export class WalletFilterComponent implements OnInit {

  @Input() _startDate: any;
  @Input() _endDate: any;
  @Input() _searchTerm: any;
  refundSel: boolean = false;
  dateSel: boolean = false;
  tollSel: boolean = false;
  vehicleSel: boolean = false;
  selectedVehicle;
  selectedTollPlaza
  tollPlaza;
  vehicles;
  startDate;
  endDate;
  setStartDate;
  setEndDate;
  optionField;
  vehicleLists;
  isCommercial: any;
  validateDate: any = [];
  data: any = {
    startDate: '',
    endDate: '',
    userOption: '',
    selectedVehicle: '',
    isCommercial: '',
  };
  constructor(
    private _modelController: ModalController,
    private _commonService: CommonService) { }

  ngOnInit() {
    this.vehicleLists = JSON.parse(localStorage.getItem("activeVehicleLookup"));
    var vehicleNumberList;
    if (this.vehicleLists !== null) {
      vehicleNumberList = Object.keys(this.vehicleLists);
      var temp = [];
      for (let sep of vehicleNumberList) {
        temp.push(
          {
            value: sep, label: sep
          }
        );
      }
      this.optionField = temp;
      this.selectedVehicle = this._searchTerm;
    }
    var today = new Date(Date.now() + ( 3600 * 1000 * 24));   // added a day (24 hours) to current datetime
    var monthStart = this._commonService.getLastThreeMonthDate(365);
    var monthEnd = today.toISOString().substr(0, 16);
    this.setStartDate = monthStart.concat('T00:00');
    this.setEndDate = monthEnd;
    this.startDate = this._startDate;
    this.endDate = this._endDate;
  }
  rechargeSelected() {
    this.vehicleSel = false;
    this.tollSel = false;
    this.dateSel = false;
    this.refundSel = false;
  }
  refundSelected() {
    this.vehicleSel = false;
    this.tollSel = false;
    this.dateSel = false;
    this.refundSel = true;
  }

  dateSelected() {
    this.vehicleSel = false;
    this.tollSel = false;
    this.refundSel = false;
    this.dateSel = true;
  }

  vahicleSelected() {
    this.tollSel = false;
    this.vehicleSel = true;
    this.refundSel = false;
    this.dateSel = false;
  }

  tollSelected() {
    this.vehicleSel = false;
    this.tollSel = true;
    this.refundSel = false;
    this.dateSel = false;
  }

  onDateChange(event) {
    var start_date = new Date(this.startDate);
    var end_date = new Date(this.endDate);
    if (end_date.getTime() < start_date.getTime()) {
      if (this.endDate) {
        this.endDate = this.startDate;
      }
    }
    this.validateDate.push(event);
  }
  resetFilters() {
    this.selectedVehicle = undefined;
    this._searchTerm = undefined;
    this.ngOnInit();
  }

  cancel() {
    this.validateDate = [];
    this.data.userOption = 'cancel';
    this._modelController.dismiss(this.data);
  }

  confirm() {
    this.data.userOption = 'confirm';
    this.data.startDate = this.startDate;
    this.data.endDate = this.endDate;
    this.data.selectedVehicle = this.selectedVehicle;
    if(this.selectedVehicle != undefined){
      this.isCommercial = this.vehicleLists[this.selectedVehicle]?.is_commercial;
      this.data.isCommercial = this.isCommercial;
    }
    this._modelController.dismiss(this.data);
  }
}
